/**
 * /en/admin/structure/types/manage/scheduling_results_appointment_c/fields
 */
import { ATTRIBUTES } from "../constants/html-constants.es6.js";
import { SEARCH_PARAM_KEYS, SESSION_STORAGE_KEYS } from "../constants/js-constants.es6.js";
import ContentType from "../core/content-type.es6.js";
import LinkField from "../core/link-field.es6.js";
import AppointmentFormParagraphField from "../fields/appointment-form-paragraph-field.es6.js";

export default class SchedulingResultsAppointmentConfirmationContentType extends ContentType {
  get appointmentForm() {
    return new AppointmentFormParagraphField({
      machineName: 'field_appointment_form',
      parentElement: this,
    });
  }

  get previousPageLink() {
    return new LinkField({
      machineName: 'field_previous_page_link',
      parentElement: this,
    });
  }

  constructor() {
    super({ machineName: 'scheduling_results_appointment_c' });
  }

  initialize() {
    this.#updatePreviousPageLink();
  }

  #updatePreviousPageLink() {
    const $anchor = this.previousPageLink.anchor.$(0);
    const overrideReferrer =
      !document.referrer ||
      new URL(document.referrer).origin !== window.location.origin;

    if (overrideReferrer) {
      // If the previous page is external or not not defined, it's likely
      // traffic from MyChart.  Send the user to the scheduling results page
      // instead.
      const href = $anchor.attr(ATTRIBUTES.HREF).trim();

      const mnemonic = new URL(window.location.href).searchParams.get(
        SEARCH_PARAM_KEYS.MNEMONIC,
      );
      const hasReferral =
        sessionStorage.getItem(SESSION_STORAGE_KEYS.HAS_REFERRAL) || false;

      const url = new URL(href, window.location.origin);
      if (mnemonic) {
        url.searchParams.set(SEARCH_PARAM_KEYS.MNEMONIC, mnemonic);
      }
      url.searchParams.set(
        SEARCH_PARAM_KEYS.HAS_REFERRAL,
        hasReferral ?? false,
      );

      $anchor.attr(ATTRIBUTES.HREF, url.href);
    } else {
      $anchor.attr(ATTRIBUTES.HREF, document.referrer);
    }
  }
}

(async () => {
  const contentType = new SchedulingResultsAppointmentConfirmationContentType();

  contentType.onRendered(() => {
    contentType.initialize();
  });
})(Drupal);
